import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';

@Component({
  selector: 'table-ui',
  templateUrl: 'table-ui.component.html',
  styleUrls: ['table-ui.component.sass']
})
export class TableUIComponent implements OnInit {
  @Input() dataTable;
  @Input() settings;
  pageNumb: number;

  @Output() selectedRow = new EventEmitter<any>();

  ngOnInit () {
    this.pageNumb = this.settings.pager.perPage;
  }

  select(e) {
    this.selectedRow.emit(e);
  }

  getPagerMenu(e: number) {
    this.dataTable.setPaging(1, e);
    this.pageNumb = e;
  }

  getIncrementsPage(inc: boolean) {
    if (this.pageNumb <= 1 && !inc) return;
    if (this.pageNumb >= this.dataTable.data.length && inc) return;
    let page = this.pageNumb;
    page = inc ? ++page : --page;
    this.pageNumb = page;
    this.dataTable.setPaging(1, page);
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/table/table-ui.component.ts